export const getIconAssistiveText = (key) => {
  switch (key) {
    case 'information':
      return 'notification';
    case 'confirmation':
      return 'status';
    case 'warning':
      return 'alert';
    case 'error':
      return 'alert';
    default:
      return '';
  }
};
